var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-pm-gnb-dataQuery-tree"},[_c('ejs-treeview',{ref:"gnbPmDataQueryTree",attrs:{"fields":_vm.fieldsOfGnbPmDataQueryTree,"nodeSelected":_vm.nodeSelectedOfGnbPmDataQueryTree}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }